export default {
  methods: {
    // 删除SPU
    handleDelSpu(spuId) {
      this.$confirm((<div class="jsx-content">
        确定删除SPU？
        <div style="color: #E63946; margin-top: 5px;">
          注意：删除后，无法恢复数据！
        </div>
      </div>), '删除-SPU')
      .then(_=>{
        const loading = this.$loading({
          target: '.app-main',
          lock: true,
        });
        const params = {
          params: {
            spuId
          }
        };
        this.$q.newProduct.deleteSpu(params)
          .then(({success}) => {
            if (success) {
              this.$notify.success({
                title: '成功',
                message: '删除SPU成功',
              });
              this.$router.push('/newProduct/newproduct-process');
            }
          })
          .finally(() => {
            loading.close();
          });
      })
      .catch(_=> {});
    }
  }
}